import moment from 'moment'
import React,{useState,useEffect,useRef} from 'react'
import { Attendance,FR } from '../../sdk'
import { Loader } from '../Default'
import { assetUrl } from '../../helpers'
import { toasterFunction } from '../Default/ToasterComponent'
import { DataTable2 } from '../Default/DataTables/DataTable2'
import { useAuthContext } from '../../context/Auth/Create'
export const DateWiseSearch = () => {
  const userAuth=useAuthContext()
  const [state, setState] = useState({ 
  loader: true, 
  date: moment().format("yyyy-MM-DD"), 
  tableLoader: true,
  dataTableLoader:false,
  tbHeader:[
    {title:"Date",name:"date",data:"date"},{title:"ID",name:"employeeId",data:"employeeId"},{title:"Name",name:"employeeName",data:"employeeName"},{title:"Company Name",data:"employeeId",render:function(data,type,row){
      return row.companyName?row.companyName:row.company?row.company:"N/A"
    }},{title:"Department",name:"department",data:"department"},{title:"CheckIn",name:"CheckIn",data:"checkIn"},{title:"CheckOut",data:"employeeId", name:"checkOut",render:function(data,type,row){
      return row.checkOut?row.checkOut:""
    }},{title:"Worked Hour",data:"employeeId",render:function(data,type,row){
      return row.timeSpend?row.timeSpend:""
    }},{title:"details",data:"employeeId",render:function(data,type,row){
    return `<button type="button" data-emloyeeId=${data} class="btn btn-theme details">Details</button>`
  }}],
  tbHeader2:[{title:"ID",name:"employeeId",data:"employeeId"},{title:"Name",name:"employeeName",data:"employeeName"},{title:"Date",name:"date",data:"date"},{title:"CheckIn",data:"employeeId",render:function(data,type,row){
    return row.checkIn?row.checkIn:""
  }},{title:"CheckOut",name:"CheckOut",data:"employeeId",render:function(data,type,row){
    return row.checkOut?row.checkOut:""
  }},{title:"cameraId",name:"cameraId",data:"employeeId",render:function(data,type,row){
    return row.cameraId?row.cameraId:""
  }},{title:"Image",data:"employeeId", render: function (data, type, row) {
  return row.imageName && row.imageName !=""?`<a href=${assetUrl}${row.imageName} target='_blank'><img src=${assetUrl}${row.imageName} style="width:100%"; /></a>`:"mannual attendnce";
  },}],
  data:[],
  data2:[],
  formAttr:{
    employee_id:"",
    check_in:"",
    date:"",
    type:"checkin",
  },
  loader2:false,
  selectEmployeeId:"",
  callBack:"",
  tableLoader2:true,
  companyName:userAuth.user.isHightAuthority?userAuth?.user.companyName:"",
  department:"",
  companies:[],
  departments:[],
  dataType:""
});
  const ref3=useRef();
  const ref4=useRef({
    employeeId:"",
    companyName:userAuth.user.isHightAuthority?userAuth?.user.companyName:"",
    department:"",
    dataType:"",
    date:moment().format("yyyy-MM-DD"),
    dataTable1Params:{
      draw:1,
      start:0,
      length:0,
      search:"",
      order:"",
      columns:"",
      sort:"asc"
    },
    dataTable2Params:{
      draw:1,
      start:0,
      length:0,
      search:"",
      order:"",
      columns:"",
      sort:"asc"
    }

  });
  let uploadRef=useRef();
  const uploadCSV=async(event)=>{
    try{
    setState((pre)=>{
      return {...pre,tableLoader:true}
    })
    let file=event.target.files[0];
    let result=await new Attendance().uploadCSV(file);
    const csvString = result.data
    .map((row) =>
      row
        .map((cell) => {
          // Escape double quotes and wrap in quotes if the cell contains a comma
          if (typeof cell === "string" && cell.includes(",")) {
            return `"${cell.replace(/"/g, '""')}"`;
          }
          return cell;
        })
        .join(",")
    )
    .join("\n");
    
    // Create a Blob with the CSV data
    const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
    
    // Create a temporary link element
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `attendance_${result.fileName}.csv`; // File name
    link.style.visibility = "hidden"; // Hide the link
    
    // Append the link to the DOM and trigger the download
    document.body.appendChild(link);
    link.click();
    
    // Clean up
    document.body.removeChild(link);
    }catch(e){
    toasterFunction.error("something went wrong,please check file format")
    }finally{
      setState((pre)=>{
        return {...pre,tableLoader:false}
      })
    }
    }
  // const apiData = async () => {
  //   try {
      
  //     setState((pre)=>{
  //     return {...pre,loader:true,tableLoader: true}
  //     })
  //     let data = {date:state.date,type:"Employee"}
  //     let result = await new FR().frInOut(data);
      
  //     if (!result.length) {
  //       alert("data not found");
  //     }
  //     let arr=[];
  //    let count=1;
  //    if(result.length){
  //    for(let val of result){
     
  //      arr.push([val.date,val.employeeId,val.employeeName,val.department?val.department:"",val.checkIn,val.checkOut,val.timeSpend,`<button type="button" data-emloyeeId=${val.employeeId} class="btn btn-theme details">Details</button>`])
  //      count++;
  //     }
  //   }
  //     setState((pre) => {
  //       return { ...pre, data: arr, loader: false, tableLoader: false }
  //     })
  //   } catch (e) {
  //     alert("error occur")
  //   }

  // }
  const apiData=async()=>{
    try{
    let users=await new FR().getCompanies();
    let departments=[]
		let find=users.find(val=>val.companyName===state.companyName);
			if(find){
			 departments=find.departments;
			}
		
		setState((pre)=>{
		  return {...pre,companies:users,loader:false,departments}
	   })
   }catch(e){
    console.log(e)
    alert("error occur")
    }

}
  const apiDataWithPagination = async (data,callBack2,date=ref4.current.date,companyName=ref4.current.companyName,department=ref4.current.department,dataType=ref4.current.dataType) => {
    try {
      setState((pre)=>{
        return {...pre,tableLoader: true}
        })
      ref4.current={...ref4.current,dataTable2Params:{
        draw:data?.draw,
        start:data?.start,
        length:data?.length,
        search:data?.search?.value || "",
        order:data?.order,
        columns:data?.columns,
        sort:data?.sort
      },
      callBack2
      }
        
      let apiData = {
        type:"Employee",
        draw:data?.draw,
        start:data?.start,
        length:data?.length,
        search:data?.search?.value || "",
        order:data?.order,
        columns:data?.columns,
        sort:data?.sort,
        date:date,
        companyName:companyName,
        department:department,
        dataType
        
              
      }
      let users=await new FR().frInOutWithPagination({...apiData});
      ref4.current.callBack2(users);
      setState((pre)=>{
        return {...pre,tableLoader: false}
        })
   
    } catch (e) {
      alert("error occur")
    }

  }

const apiData2WithPagination = async (data,callBack,employeeId=ref4.current.employeeId) => {
    try {
       setState((pre)=>{
        return {...pre,tableLoader2:true}
       })
      ref4.current={...ref4.current,employeeId,dataTable1Params:{
        draw:data?.draw,
        start:data?.start,
        length:data?.length,
        search:data?.search?.value || "",
        order:data?.order,
        columns:data?.columns,
        sort:data?.sort
      },
      callBack
      }
        
      let apiData = {
        type:"Employee",
        draw:data?.draw,
        start:data?.start,
        length:data?.length,
        search:data?.search?.value || "",
        order:data?.order,
        columns:data?.columns,
        sort:data?.sort,
        date:ref4.current.date,
        employeeId:String(employeeId)
              
      }
      if(employeeId ===""){
      return ;
      }
      let users=await new FR().employeeAttendanceDetailsWithpagination({...apiData});
      ref4.current.callBack(users);
      setState((pre)=>{
        return {...pre,tableLoader2:false}
       })
    } catch (e) {
      console.log(e)
      alert("error occur")
    }

}

const onSubmitAdd=async (event)=>{
  event.preventDefault();
  ref3.current.disabled=true;
  ref3.current.firstElementChild.style.display="inline-block"
 try{
 await new Attendance().addMannual(state.formAttr);
 toasterFunction.success("attendance has been added");
 window.location.reload(); 
 }catch(e){
 if(e.response.status===300){
  toasterFunction.error("Employee already taken")
 }else{
  Object.values(e.response.data)[0].forEach(val=>{
    toasterFunction.error(val)
  })
}
ref3.current.disabled=false;
ref3.current.firstElementChild.style.display="none"
}
}
const onHandlerForm=(event)=>{
  let key=event.target.name;
  let value=event.target.value;
  console.log(key,value)
  let oldState={...state}
  oldState.formAttr[key]=value;
  setState((pre)=>{
    return {...pre,...oldState}
  })
  
}
const onHandler = (event) => {
  let date = moment(event.target.value).format("yyyy-MM-DD");
  ref4.current.date=date;
  ref4.current.employeeId="";
  setState((pre)=>{
    return {...pre,date:date}
      })
    
    
  }
const onDetails=(employeeId)=>{
  apiData2WithPagination({...ref4.current,draw:ref4.current.dataTable1Params.draw,length:10,start:0,search:""},ref4.current.callBack,employeeId)
  window.$("#showImg").modal("show");
    // setState((pre)=>{
    //   return {...pre,employeeId}
    // })
   
   
  }
  // useEffect(() => {
  //   setState((pre)=>{
  //       return {...pre,loader:true,tableLoader: true}
  //       })
  // }, [])
  const onHandlerType=(event)=>{
    let key=event.target.name;
    let value=event.target.value;
    if(key==="companyName"){
    let departments=[];
    let find=state.companies.find(val=>val.companyName===value);
    if(find){
     departments=find.departments;
    }
    ref4.current={...ref4.current,[key]:value,department:""}
    setState((pre)=>{
      return{...pre,departments,department:""}
    })
    }
    else{
     ref4.current={...ref4.current,[key]:value}
     setState((pre)=>{
       return{...pre,[key]:value}
     })
    }
   }
  useEffect(()=>{
    apiData();
    },[])
  if (!state.loader) {
    return (
      <>
        <div className="card mb-3">
          {/* BEGIN card-body */}
          <div className="card-body">
            <div className="fw-bold small mb-3">
              <div className='row' style={{textAlign:"center"}}>
              <div className="col-12 mb-4">
                <span className="flex-grow-1">Employees FR Daily Report</span>
              </div>
              <div className="col-12">
            <button type="button" onClick={()=>{
       uploadRef.current.click()
      }} class="btn btn-theme">Upload CSV For Comparison</button>
     <input type={"file"} ref={uploadRef} style={{display:"none"}}  accept=".xlsx, .xls" 
       onChange={uploadCSV}/>
      
              </div>
            <div className="col-2"></div>
              <div className="col-sm-12 col-md-3 col-lg-2">
      <div class="form-group mb-3">
        <label class="form-label text-white fw-bold" for="exampleFormControlSelect1" ></label>
        <select class="form-select" name="companyName" id="exampleFormControlSelect1" onChange={onHandlerType} style={{color:"rgb(60, 210, 165)"}}>
          <option value="" selected={ref4.current.companyName===""}>Company</option>
          {state.companies.map((val,index)=>{
            return  <option key={index} value={val.companyName} selected={ref4.current.companyName===val.companyName}>{val.companyName}</option>
          })}
         
          
          </select>
          </div>
       </div>
       <div className="col-sm-12 col-md-3 col-lg-2">
      <div class="form-group mb-3">
        <label class="form-label text-white fw-bold" for="exampleFormControlSelect2" ></label>
        <select class="form-select" name="department" id="exampleFormControlSelect2" onChange={onHandlerType} style={{color:"rgb(60, 210, 165)"}}>
        <option value="" selected={ref4.current.companyName===""}>Department</option>
          {state.departments.map((val,index)=>{
            return  <option key={index} value={val} selected={ref4.current.department===val}>{val}</option>
          })}
          </select>
          </div>
       </div>
       <div className="col-sm-12 col-md-3 col-lg-2">
      <div class="form-group mb-3">
        <label class="form-label text-white fw-bold" for="exampleFormControlSelect2" ></label>
        <select class="form-select" name="dataType" id="exampleFormControlSelect2" onChange={onHandlerType} style={{color:"rgb(60, 210, 165)"}}>
        <option value="" selected={ref4.current.dataType===""}>Type</option>
        <option value="1" selected={ref4.current.dataType==="1"}>Last Check Out Missing</option>
        <option value="2" selected={ref4.current.dataType==="2"}>Last Check Out Not Missing</option>
         
          </select>
          </div>
       </div>
              <div className="col-2">
                {/* <button type="button" class="btn btn-theme" onClick={exportCsv}>Export Csv</button> */}
                <div class="form-group mb-3" style={{ width: "85%" }}>
                  <label class="form-label" for="exampleFormControlSelect1"></label>
                  <input type="date" class="form-control" id='date' name='date' placeholder="dd/mm/yyyy" onChange={onHandler} value={state.date} style={{color:"rgb(60, 210, 165)"}}/>
                </div>
              </div>
             
              <div className='col-2'>
                <label class="form-label" for="Location"></label>
                <br />
                <button type="button" class="btn btn-theme" onClick={()=>apiDataWithPagination({...ref4.current.dataTable2Params},ref4.current.callBack2)}>Search</button>
              </div>
              {(userAuth.user && userAuth.user.permissions.includes("Add Attendance")) && <>    <div className="col d-flex" style={{justifyContent:"center",alignItems:"center",}}>
              <button type="button" class="btn btn-theme" onClick={()=>{
                window.$("#showForm").modal("show")
              }}>Add Attendance</button>
              </div></>}
            
              </div>
            </div>

            {state.tableLoader && <><Loader/></>}
   
   <div className="col-12">
     
  {<DataTable2 headers={state.tbHeader} image={true}  order={[[0, 'desc']]} count={"paginationTable1"} ajax={apiDataWithPagination} onDetails={onDetails} isLoading={state.dataTableLoader}/>}
  
   </div>
          </div>
          <div className="card-arrow">
            <div className="card-arrow-top-left" />
            <div className="card-arrow-top-right" />
            <div className="card-arrow-bottom-left" />
            <div className="card-arrow-bottom-right" />
          </div>
        </div>
        <div class="modal" id="showForm">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Add New Attendance</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body">
        <div className="row">
          <div className="col-12">
           <form onSubmit={onSubmitAdd}>
          <div className="row">
          <div className="col-xl-6" >
          <div className="form-group mb-3">
          <label className="form-label text-white" >
              Employee ID
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Employee Id"
              name='employee_id'
              value={state.formAttr.employee_id}
              onChange={onHandlerForm}
              required
            />
          </div>
          </div>
          <div className="col-xl-6" >
          <div className="form-group mb-3">
          <label class="form-label" for="exampleFormControlSelect1">Date</label>
                  <input type="date" class="form-control text-white" id='date' name='date' placeholder="dd/mm/yyyy" onChange={onHandlerForm} value={state.formAttr.date}/>
          </div>
          </div>
          <div className="col-xl-6" >
          <div className="form-group mb-3">
          <label className="form-label text-white" >
              Time
            </label>
            <input
              type="time"
              className="form-control"
              placeholder="Enter Time"
              name='check_in'
              value={state.formAttr.check_in}
              onChange={onHandlerForm}
              required
            />
          </div>
          </div>
          <div className="col-xl-6" style={{paddingTop: "5px"}}>
   <div className="text-white text-opacity-50 mb-1">
    <b>Type</b>
  </div>
  <div className="form-group mb-4">
    <div className="form-check form-check-inline">
      <input
        className="form-check-input"
        type="radio"
        name="type"
        id="defaultRadio1"
        value="checkin"
        onChange={onHandlerForm}
        checked={state.formAttr.type==="checkin"}
        required

      />
      <label className="form-check-label" htmlFor="defaultRadio1">
        Check in
      </label>
    </div>
    <div className="form-check form-check-inline">
    <input
        className="form-check-input"
        type="radio"
        name="type"
        id="defaultRadio2"
        value="checkout"
        onChange={onHandlerForm}
        checked={state.formAttr.type==="checkout"}
        required

      />
      <label className="form-check-label" htmlFor="defaultRadio2">
        Check Out
      </label>
    </div>
   
  </div>
</div>

         
     
          <div className="col-xl-12"style={{textAlign:"center"}}>
          <button type="submit" class="btn btn-outline-theme w-25" ref={ref3} disabled={false}>Add <div className="spinner-border" role="status" style={{height:"15px",width: "1rem" ,display:"none"}}></div></button>
          </div>
     
      </div>
    </form>
  </div>

        </div>
       </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-default " data-bs-dismiss="modal">Close</button>
        
      </div>
    </div>
     
     
    </div>
  </div>
</div>
        <div class="modal" id="showImg">
          <div class="modal-dialog modal-xl">
            <div class="modal-content">
            <div class="modal-header">
            {state.tableLoader2 && <Loader/>}
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
  
              <div class="modal-body">
              
              {<DataTable2 headers={state.tbHeader2} data={state.data2} image={true}  reverse={true} count={"paginationTable2"} ajax={apiData2WithPagination} />}
              </div>

            </div>
          </div>
        </div>


      </>


    )
  }
  else {

    return (<>
      <Loader />
    </>)
  }

}
